import { generateSeoProps } from '../generateSeoProps';
export const getHomeSeoProps = () => {
	return generateSeoProps({ 
		title: 'Pharmuni: Advance Your Pharma Career with GMP Certificates', 
		noIndex: false,
		description: `Earn ISO-backed GMP and pharma certificates online. Gain job-ready skills, plan your career path and unlock higher-paying roles—learn anytime.`,
	});
};
